import { render, staticRenderFns } from "./DebateProfile.vue?vue&type=template&id=37c33c4f&"
import script from "./DebateProfile.vue?vue&type=script&lang=js&"
export * from "./DebateProfile.vue?vue&type=script&lang=js&"
import style0 from "./DebateProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
